import React from 'react';
import styled from 'styled-components';
import Stepper from './Stepper';

const Banner = ({ totalSteps, currentStep, setCurrentStep, variant }) => {
  return (
    <StyledBanner variant={variant}>
      <div className="inner-banner">
        <div className="img-container">
          {variant !== 'warstic' && (
            <img
                src="https://res.cloudinary.com/team-triton/image/upload/f_auto,q_auto/Triton_Logo_White"
                alt="Team Triton Logo"
            />
          )}
        {variant && variant === 'boa' && (
          <img src="BoA_Logo_no_bg.png" alt="BoA Logo" style={{ width: '80px' }} />
        )}
        {variant && variant === 'hrd' && (
          <img src="HRD_Logo.png" alt="Home Run Dugout Logo" style={{ width: '100px' }} />
        )}
        {variant && variant === 'boa2' && (
          <img src="BoA2_Logo.jpg" alt="BoA Logo" style={{ width: '100px' }} />
        )}
        {variant && variant === 'warstic' && (
          <img src="Warstic_logo.jpeg" alt="Warstic Logo" style={{ width: '200px' }} />
        )}
        </div>
        <Stepper
          totalSteps={totalSteps}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          variant={variant}
        />
      </div>
    </StyledBanner>
  );
};

const StyledBanner = styled.div`
  background-color: ${props => props.variant === 'warstic' ? '#000' : 'var(--red)'};
  width: 100%;
  padding: 1rem 0;
  display: flex;
  align-items: center;
  z-index: 10;
  /* position: sticky;
  top: 0; */

  .img-container {
    display: flex;
    align-items: center;
  }

  .inner-banner {
    padding: 0 2rem;
    border: 10px solid #fff;
    border-right: none;
    border-left: none;
    flex: 1;
    display: flex;
    align-items: center;

    img {
      width: 200px;
      height: auto;
    }
  }

  @media (max-width: 500px) {
    padding: 0.5rem 0;
    .inner-banner {
      padding: 0.5rem 1rem;
      flex-direction: column;
      width: 100%;
      gap: 0.5rem;
    }
  }
`;

export default Banner;
